import './LocateAddress.css';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { vector } from '../../_config/layers/';
import LocateAddressModal from './component/LocateAddressModal';
import { transformExtent, fromLonLat } from 'ol/proj';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Button } from 'primereact/button';

function LocateAddress({ map }) {
  const { t } = useTranslation();
  const restoreElement = useRef();
  const locateAddressInputRef = useRef();
  const [address, setAddress] = useState('');
  const [active, setActive] = useState(false);

  const positionFeature = new Feature();

  const positionFeatureStyle = new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({ color: 'rgb(236, 118, 8)' }),
      stroke: new Stroke({ color: '#000000', width: 2 }),
    }),
  });

  const handleClick = () => {
    setActive((active) => !active);
  };

  const pointAddressOnMap = ({ coordinates }) => {
    vector.getSource().clear();
    positionFeature.setGeometry(null);
    coordinates = fromLonLat(coordinates, 'EPSG:4326');
    positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
    positionFeature.setStyle(positionFeatureStyle);
    vector.getSource().addFeature(positionFeature);
  };

  const zoomAddressOnMap = (bbox) => {
    const extent = transformExtent(bbox, 'EPSG:4326', 'EPSG:4326');
    map.getView().fit(extent, map.getSize());
    locateAddressInputRef.current.className = 'input-group-text LocateAddressButton';
    setActive(false);
  };

  const locateAddressOnMap = ({ bbox, geometry }) => {
    pointAddressOnMap(geometry);
    zoomAddressOnMap(bbox);
  };

  const handleGeocoding = async () => {
    const url = `https://nominatim.openstreetmap.org/search?q=${address}&format=geojson`;

    locateAddressInputRef.current.className = 'input-group-text LocateAddressButton is-valid';

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data?.features?.[0]) {
        locateAddressOnMap(data.features[0]);
      } else {
        locateAddressInputRef.current.className = 'input-group-text LocateAddressButton is-invalid';
      }
    } catch (err) {
      locateAddressInputRef.current.className = 'input-group-text LocateAddressButton is-invalid';
      console.error(err);
    }
  };

  return (
    <div id="LocateAddress" className="LocateAddress">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('locateAddress.tooltip')}
        title={t('locateAddress.tooltip')}
        onClick={handleClick}
        ref={restoreElement}
        icon="pi pi-map-marker"
      >
      
      </Button>

      <LocateAddressModal
        locateAddressInputRef={locateAddressInputRef}
        address={address}
        setAddress={setAddress}
        handleGeocoding={handleGeocoding}
        active={active}
        callback={setActive}
      />
    </div>
  );
}

export default LocateAddress;
